<template>
  <div class="data-table-with-title">
    <div class="data-table-with-title__title">
      {{ title }}
    </div>
    <div class="data-table-with-title__subtitle-wrap">
      <p class="data-table-with-title__subtitle">
        {{ subtitle }}
      </p>
      <p class="data-table-with-title__subtitle">
        {{ remark }}
      </p>
    </div>
    <div class="data-table-with-title__table">
      <DataTable
        :table-overflow="tableOverflow"
        :column-header="columnHeader"
        :row-data="rowData"
        @click="$_recordPopupOpen($event)"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "DataTableWithTitle",
  props: {
    tableOverflow: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    remark: {
      type: String,
      default: "",
    },
    columnHeader: {
      type: Array,
      default() {
        return [];
      },
    },
    rowData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    $_recordPopupOpen($event) {
      this.$emit("click", $event);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/data-table-with-title";
</style>